import React from 'react';
import { gql } from 'apollo-boost';
import { useQuery } from '@apollo/react-hooks';
import PageDefaultsContext from './PageDefaultsContext';

const PAGE_DEFAULTS_QUERY = gql`
  query getPageDefaults {
    pageDefaults {
      initialGrantAllotments
    }
  }
`;

function PageDefaults({ children }) {
  const { loading, error, data = {} } = useQuery(PAGE_DEFAULTS_QUERY);

  if (loading) return null;

  if (error || !data.pageDefaults) {
    data.pageDefaults = 50;
  }

  return (
    <PageDefaultsContext.Provider value={data.pageDefaults}>
      {children}
    </PageDefaultsContext.Provider>
  );
}

export default React.memo(PageDefaults);
